import script from "./BulkDevices.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkDevices.vue?vue&type=script&setup=true&lang=js"

import "./BulkDevices.vue?vue&type=style&index=0&id=e2bbb04a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2bbb04a"]])

export default __exports__